module.exports = __webpack_public_path__ + "img/category_roadtrips.7657e04.png";